import React, {memo} from 'react';
import BarGroup from "../Dashboard/BarGroup";

/**
 * This class generates all bar graphes needed on the page Übersicht
*/
class BarChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            barHeight: 100,
            height: this.props.height
        };
    }

    render() {

        return <svg width={this.props.width} height={this.props.height} viewBox={`-${(this.props.width-this.props.height)/2} 0 ${this.props.width} ${this.props.height}`} color="white">
            <g color="black">
                {
                    <g transform={`translate(125, ${this.props.ytrans})`}>
                        <BarGroup d={this.props.data} barHeight={this.state.barHeight}/>
                    </g>
                }
                <text x={(this.props.ptX1 + this.props.ptX2)/2} y="10%" dominantBaseline="middle" textAnchor="middle" fill="white">{this.props.title}</text>
                <line x1={this.props.ptX1} y1={this.props.ptY1} x2={this.props.ptX2} y2={this.props.ptY2} stroke="black" strokeWidth="0.5"/>
            </g>
        </svg>

    }
}

export default memo(BarChart);